import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './tabs.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
import * as $ from 'jquery';
var Tabs = /** @class */ (function (_super) {
    tslib_1.__extends(Tabs, _super);
    function Tabs(element) {
        return _super.call(this, element) || this;
    }
    Tabs.prototype.init = function () {
        var _this = this;
        if (this.element.getAttribute('data-autoheight')) {
            this.autoHeight = this.element.getAttribute('data-autoheight').toString();
        }
        else {
            this.autoHeight = 'true';
        }
        this.tabComponent = $(this.element);
        this.tabsContent = Array.from(this.tabComponent.find('.tabs__item-content'));
        setTimeout(function () {
            _this.equalHeights();
        }, 100);
        this.initTabs();
        this.slideRunner = this.tabComponent.find('.tabs__slide-runner');
        this.tabTriggers = Array.from(this.tabComponent.find('.js-tab-trigger'));
        this.activeTabTrigger = this.tabComponent.find('.tabs__item--active');
        this.activeTab = this.tabComponent.find('.tabs__item-content--active');
        $(document).ready(function () {
            _this.moveSlideRunner();
        });
    };
    Tabs.prototype.bindEvents = function () {
        var _this = this;
        this.tabTriggers.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleTabs(event);
            _this.moveSlideRunner();
        }); });
        window.addEventListener('resize', this.debounce(function () {
            _this.moveSlideRunner();
        }, 250, false));
        window.addEventListener('resize', this.onResize.bind(this));
    };
    Tabs.prototype.onResize = function () {
        var _this = this;
        setTimeout(function () {
            _this.equalHeights();
        }, 100);
    };
    Tabs.prototype.initTabs = function () {
        var tabs = this.tabComponent.find('.tabs__item');
        var tabsContent = this.tabsContent;
        for (var i = 0; i < tabs.length; i++) {
            var tabGuid = this.generateGuid();
            $(tabs[i]).attr('data-target', "tabs__item-" + tabGuid);
            $(tabsContent[i]).attr('id', "tabs__item-" + tabGuid);
        }
    };
    Tabs.prototype.equalHeights = function () {
        if (this.autoHeight == 'true') {
            var elements = this.tabsContent;
            for (var i = 0; i < elements.length; i++) {
                elements[i].style.height = 'auto';
            }
            if (MediaQueryService.getMediaQuery() !== 'small' && MediaQueryService.getMediaQuery() !== 'x-small') {
                var tallestElement = 0;
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    var elHeight = el.offsetHeight;
                    if (elHeight > tallestElement) {
                        tallestElement = elHeight;
                    }
                }
                for (var i = 0; i < elements.length; i++) {
                    elements[i].style.height = tallestElement + "px";
                    if (!elements[i].classList.contains('tabs__item-content--active')) {
                        elements[i].style.height = '0';
                    }
                }
            }
        }
    };
    Tabs.prototype.toggleTabs = function (event) {
        if (!$(event.currentTarget).hasClass('tabs__item--active')) {
            this.closeTab();
            this.activeTabTrigger = $(event.currentTarget);
            this.activeTab = this.tabComponent.find("#" + this.activeTabTrigger.attr('data-target'));
            this.openTab();
        }
        this.equalHeights();
    };
    Tabs.prototype.moveSlideRunner = function () {
        var tabPositionLeft = this.activeTabTrigger.position().left;
        var tabWidth = this.activeTabTrigger.width();
        this.slideRunner
            .width(0)
            .css('left', tabPositionLeft + "px")
            .show()
            .delay(350)
            .width(tabWidth);
    };
    Tabs.prototype.generateGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    Tabs.prototype.closeTab = function () {
        this.activeTabTrigger.removeClass('tabs__item--active');
        this.activeTab.removeClass('tabs__item-content--active');
    };
    Tabs.prototype.openTab = function () {
        this.activeTabTrigger.addClass('tabs__item--active');
        this.activeTab.addClass('tabs__item-content--active');
    };
    Tabs.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };
    return Tabs;
}(Base));
export { Tabs };



//////////////////
// WEBPACK FOOTER
// ./components/tabs/tabs.component.ts
// module id = 535
// module chunks = 0